import { Gauge } from "lucide-react";
import { ComingSoonPage } from "./ComingSoonPage";

export function VelocityPage() {
  return (
    <ComingSoonPage title="Velocity" description="Track how quickly work moves through the workspace." Icon={Gauge} />
  );
}
